export default {
  firstName: {
    en: 'Type your family name here',
    ar: 'اكتب اسم العائلة هنا'
  },

  firstNameError: {
    ar: '',
    en: ''
  },

  familyName: {
    en: 'Family Name',
    ar: 'اسم العائلة'
  },

  familyNameError: {
    nl: 'Voer een geldige voornaam in',
    ar: '',
    en: ''
  },

  familyMembers: {
    en: 'Number of family members',
    ar: 'عدد أفراد العائلة'
  },

  familyMembersError: {
    en: 'Min len 1 max 8',
    ar: ''
  },

  nameAvatar: {
    en: 'Name family member',
    ar: 'اسم فرد من العائلة'
  },

  namePlaceholder: {
    en: 'Type your name here',
    ar: 'اكتب اسمك هنا'
  },

  nameAvatarError: {
    nl: 'Voer een geldige voornaam in',
    ar: '',
    en: ''
  }
};
